import request from "@/utils/request";

export function signApply (data){
  return request({
    url:'/osp/companySign/saveBo',
    method:'post',
    data: data
  })
}

export function signQuery (data){
  return request({
    url:'/osp/companySign/queryPageList',
    method:'post',
    data: data
  })
}

export function signOff (data){
  return request({
    url:'/osp/companySign/updateStatus',
    method:'post',
    data: data
  })
}

export function signConfirm (data){
  return request({
    url:'/osp/abcProxy/verify',
    method:'post',
    data: data
  })
}

export function infoUpload(data){
  return request({
    url:'/osp/abcProxy/upload',
    method:'post',
    data: data
  })
}

export function querySubMerAcct(data){
  return request({
    url:'/osp/abcProxy/querySubMerAcct',
    method:'post',
    data: data
  })
}

export function signUpK(data){
  return request({
    url:'/osp/customerSign/signUp',
    method:'post',
    data: data
  })
}

export function signOffK(data){
  return request({
    url:'/osp/customerSign/signOff',
    method:'post',
    data: data
  })
}

export function signKQuery(data){
  return request({
    url:'/osp/abcProxy/authorization/signQuery',
    method:'post',
    data: data
  })
}

export function signInfoQuery(data){
  return request({
    url:'/osp/abcProxy/authorization/signInfo',
    method:'post',
    data: data
  })
}

// export function customerSign(data){
//   return request({
//     url:'/osp/signRecord/saveBo',
//     method:'post',
//     data: data
//   })
// }

export function QuerySignRecord(data){
  return request({
    url:'/osp/signRecord/queryPageList',
    method:'post',
    data:data
  })
}


